<template>
	<div class="acessar-pedido-view">
		<az-back-button id="azBackButton" text="voltar para listagem" :route="route"></az-back-button>
		<az-container>
			<cabecalho-pagina>
				<template #numero_editando>
					<campo-editar-numero
						:exibir="exibirModalNumeroPedidoEditando"
						:titulo="tituloModalNumeroPedidoEditando"
						:rules="regrasNumeroPedido"
						:situacao="informacoesPedido.situacao"
						:situacoes-validas="situacoesValidas"
						:numero-is-manual="numeroDoPedidoIsManual"
						:is-ata-cancelada="isAtaCancelada"
						@abrir-ou-fechar-modal="abrirOufecharModalNumeroPedidoEditando"
						@salvar-numero="salvarNumeroPedido"
						@pode-exibir-acao="podeExibirAcaoEditar"
					>
					</campo-editar-numero>
				</template>
				<template #dataCadastro_editando="{ texto }">
					<v-list-item-subtitle id="subtitulo" class="subtitulo">
						<texto-tooltip
							class="white--text"
							:texto="texto.subtitulo.texto"
							:texto-tooltip="informacoesPedido.nomeUsuario"
							:tamanho-maximo="40"
						>
						</texto-tooltip>
					</v-list-item-subtitle>
				</template>
				<template #bpm_activity>
					<v-list-item-content v-if="!isPedidoRascunho">
						<v-list-item-title id="titulo" class="label">
							<span class="white--text" v-html="atividadeNome"></span>
						</v-list-item-title>
						<v-list-item-subtitle id="subtitulo" class="subtitulo">
							<texto-tooltip
								class="white--text"
								:tamanho-maximo="25"
								:texto="atividadeSituacao"
							></texto-tooltip>
						</v-list-item-subtitle>
					</v-list-item-content>
				</template>
				<template #actions>
					<botao-primario
						v-if="existeRevisaoParaPedido && !isAtaCancelada"
						outlined
						:nome-botao="revisao.tipo"
						cor-de-fundo="white"
						class="mr-4"
						@click="criarRevisaoPedidoUtilizacao"
					></botao-primario>
					<v-divider v-if="existeRevisaoParaPedido" vertical color="white" class="mr-4"></v-divider>
					<botao-processo-digital
						v-if="podeExibirBotaoProcessoDigital && !existeRevisaoParaPedido"
						class="acessar-pedido-view__btn-bpm mr-2"
						:is-edocs="isIntegracaoEdocsAtivo"
						:is-ata-cancelada="isAtaCancelada"
						@acessar="visualizarProcessoDigital"
						@enviar-edocs="enviarEdocs"
						v-az-auth="permissoes.pedidoUtilizacaoProcessoDigitalVisualizar"
					></botao-processo-digital>
					<arp-bpm-pedido
						botao-classe="acessar-pedido-view__btn-bpm"
						tem-divisor="true"
						v-if="!isPedidoRascunho && !isAtaCancelada"
						:chave-de-negocio="`${$route.params.id}`"
						@apos-acao-fluxo="acaoAposFluxo"
					></arp-bpm-pedido>
					<menu-acoes
						v-if="podeExibirBotaoAcoesCabecalho"
						class="acessar-pedido-menu-acoes-cabecalho"
						cor-icone="--v-error-base"
						icone-secondary="mdi-dots-vertical"
						:outlined="true"
						block
						corDeFundo="grey"
						:acoes-menu="acoesMenuCabecalho"
						tamanho-icone-menu="18px"
						@concluir="abrirModalConfirmacaoConcluirPedido"
						@autorizar="abrirModalAutorizarPedido"
						@nao-autorizar="abrirModalNaoAutorizarPedido"
						@processo-digital="visualizarProcessoDigital"
						@efetivar="abrirModalConfirmarEfetivacao"
						@enviar-pedido-integracao="enviarPedidoIntegracao"
						@acessar-processo-digital="visualizarProcessoDigital"
						@enviar-edocs="enviarEdocs"
					>
					</menu-acoes>
				</template>
			</cabecalho-pagina>
			<az-container>
				<painel-com-tabs :getter="getterAbas" :key="atualizarListagem" ref="painelTabsRef"></painel-com-tabs>
			</az-container>
			<v-spacer></v-spacer>
		</az-container>
		<modal-confirmacao
			id="concluirPedido"
			:exibir="exibirModalConcluirPedido"
			:mensagem="mensagemConcluirPedido"
			@fechar-modal="abrirModalConfirmacaoConcluirPedido"
			@confirmar="concluirPedido"
			:subtituloModal="subtituloModalConcluirPedido"
			:tituloModal="tituloModalConcluirPedido"
		></modal-confirmacao>
		<modal-confirmacao
			id="confirmarEfetivarPedido"
			:exibir="exibirModalEfetivarPedido"
			mensagem="A efetivação não poderá ser desfeita."
			titulo-modal="Deseja realmente efetivar o pedido e abater os saldos da ata?"
			@fechar-modal="fecharModal"
			@confirmar="efetivarPedido"
		>
		</modal-confirmacao>

		<modal-confirmacao
			id="autorizarPedido"
			:exibir="exibirModalAutorizarPedido"
			titulo-modal="Autorizar Pedido?"
			@fechar-modal="fecharModal"
		>
			<template #acoes>
				<botao-primario nome-botao="NÃO" class="mr-5" min-width="100" @click="fecharModal"></botao-primario>
				<botao-cancelar label="SIM" @cancelar="autorizarPedido"></botao-cancelar>
			</template>
		</modal-confirmacao>
		<modal-confirmacao
			id="naoAutorizarPedido"
			:exibir="exibirModalNaoAutorizarPedido"
			titulo-modal="Não Autorizar Pedido?"
			@fechar-modal="fecharModal"
		>
			<template #acoes>
				<botao-primario nome-botao="NÃO" class="mr-5" min-width="100" @click="fecharModal"></botao-primario>
				<botao-cancelar label="SIM" @cancelar="naoAutorizarPedido"></botao-cancelar>
			</template>
		</modal-confirmacao>
		<modal-edocs
			v-if="podeExibirModalEdocs"
			:id-processo-digital="idProcessoDigital"
			:exibir="exibirModalEdocs"
			@fechar-modal-edocs="fecharModalEdocs"
		></modal-edocs>
	</div>
</template>
<script>
import PainelComTabs from '@/views/components/PainelComTabs.vue'
import { actionTypes, getterTypes, mutationTypes, permissoes, routesNames, situacoes } from '@/core/constants'
import validacaoPedido from '@/views/mixins/validacaoPedido'
import cabecalhoPedido from '@/views/mixins/cabecalhoPedido'
import deslogarOrgao from '@/views/mixins/deslogarOrgao'
import CampoEditarNumero from '@/views/components/cabecalho/CampoEditarNumero.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import arpBpmMixin from '@/views/mixins/bpm/arp-bpm-mixin'
import { mapGetters } from 'vuex'
import fluxoPedido from '@/views/mixins/bpm/fluxoPedido'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import TipoOcorrencia from '@/core/constants/tipo-ocorrencia'
import BotaoProcessoDigital from '@/views/components/BotaoProcessoDigital.vue'

export default {
	name: 'acessar-pedido-view',
	components: { BotaoProcessoDigital, BotaoPrimario, TextoTooltip, CampoEditarNumero, PainelComTabs },
	mixins: [validacaoPedido, cabecalhoPedido, deslogarOrgao, arpBpmMixin, fluxoPedido],
	provide() {
		return {
			idPedido: this.$route.params.id,
			isEditar: this.$route.params.tipoAcesso === 'editar',
			numeroDoPedidoIsManual: this.$store.state.parametrosSistema.numeroDoPedidoIsManual,
		}
	},
	data() {
		return {
			isProcessoDigitalAtivo: this.$store.state.parametrosSistema.isProcessoDigitalAtivo,
			isIntegracaoEdocsAtivo: this.$store.state.parametrosSistema.isIntegracaoEdocsAtivo,
			exibirModalEdocs: false,
			exibirModalConcluirPedido: false,
			exibirModalEfetivarPedido: false,
			exibirModalAutorizarPedido: false,
			exibirModalNaoAutorizarPedido: false,
			mensagemConcluirPedido: 'A conclusão não poderá ser cancelada!',
			subtituloModalConcluirPedido: 'Deseja realmente concluir o pedido?',
			tituloModalConcluirPedido: 'Concluir',
			atualizarListagem: 0,
			acoesMenuCabecalho: [
				{
					titulo: 'Processo Digital',
					evento: 'acessar-processo-digital',
					icone: {
						nome: 'mdi-open-in-new',
					},
					authorization: permissoes.pedidoUtilizacaoProcessoDigitalVisualizar,
					isVisible: this.podeExibirBotaoProcessoDigitalNoMenuAcoes,
				},
				{
					titulo: 'Enviar E-Docs',
					evento: 'enviar-edocs',
					authorization: permissoes.pedidoUtilizacaoProcessoDigitalVisualizar,
					isVisible: this.podeExibirBotaoEnviarEdocs,
				},
				{
					titulo: 'Autorizar',
					icone: {
						nome: 'mdi-check-circle',
					},
					evento: 'autorizar',
					authorization: permissoes.pedidoUtilizacaoedidoUtilizacaoAutorizar,
					isVisible: this.podeExibirAutorizarPedido,
				},
				{
					titulo: 'Não Autorizar',
					icone: {
						nome: 'mdi-progress-check',
					},
					evento: 'nao-autorizar',
					authorization: permissoes.pedidoUtilizacaoedidoUtilizacaoAutorizar,
					isVisible: this.podeExibirAutorizarPedido,
				},
				{
					titulo: 'Concluir',
					icone: {
						nome: 'mdi-check-all',
					},
					evento: 'concluir',
					authorization: permissoes.pedidoUtilizacaoPedidoUtilizacaoConcluir,
					isVisible: this.podeExibirConcluirPedido,
				},
				{
					titulo: 'Efetivar',
					icone: {
						nome: 'mdi-check-circle-outline',
					},
					evento: 'efetivar',
					authorization: permissoes.pedidoUtilizacaoEfetivar,
					isVisible: this.podeExibirEfetivarPedido,
				},
				{
					titulo: 'Reenviar Pedido',
					icone: {
						nome: 'mdi-send',
					},
					evento: 'enviar-pedido-integracao',
					authorization: permissoes.pedidoUtilizacaoIntegracaoEnviar,
					isVisible: this.podeExibirEnviarPedidoIntegracao,
				},
			],
			isIntegracaoRecebimentoEntregaAtivo:
				this.$store.state.parametrosSistema.isIntegracaoRecebimentoEntregaAtivo,
			keyAtividadeRecebimentoEntrega: this.$store.state.parametrosSistema.keyAtividadeRecebimentoEntrega,
			route: {},
		}
	},
	computed: {
		...mapGetters({
			isPedidoRascunho: getterTypes.PEDIDO.IS_PEDIDO_RASCUNHO,
		}),
		getterAbas() {
			return getterTypes.PEDIDO.GET_ABAS_PEDIDO
		},
		podeExibirBotaoProcessoDigital() {
			return this.isProcessoDigitalAtivo && !this.estaEmRascunho(this.informacoesPedido)
		},
		podeExibirBotaoAcoesCabecalho() {
			const permissoes = this.getTodasPermissoesBotaoMenuCabecalho()

			return (
				permissoes.deveAutorizarPedido() ||
				permissoes.deveConcluirPedido() ||
				permissoes.deveEfetivarPedido() ||
				permissoes.deveEnviarParaIntegracao() ||
				this.existeRevisaoParaPedido
			)
		},
		idProcessoDigital() {
			return this.informacoesPedido.idProcessoDigital
		},
		podeExibirModalEdocs() {
			return this.isIntegracaoEdocsAtivo && this.exibirModalEdocs
		},
		existeRevisaoParaPedido() {
			return this.revisao !== null && !!this.revisao.id
		},
		isAtaCancelada() {
			return this.informacoesPedido.ataRegistroPreco?.situacao === situacoes.ATA.CANCELADO.value
		},
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.PEDIDO.RESET_INFORMACOES)
	},
	async mounted() {
		await Promise.all([this.inicializarComponente(), this.carregarInstancia(this.$route.params.id.toString())])
	},
	methods: {
		fecharModal() {
			this.exibirModalEfetivarPedido = false
			this.exibirModalAutorizarPedido = false
			this.exibirModalNaoAutorizarPedido = false
		},
		abrirModalConfirmarEfetivacao() {
			this.exibirModalEfetivarPedido = true
		},
		async visualizarProcessoDigital() {
			const { url } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.VISUALIZAR_PROCESSO_DIGITAL,
				this.informacoesPedido.id,
			)

			if (!url && this.isIntegracaoEdocsAtivo) {
				this.mostrarNotificacaoWarning(
					'Não é possível acessar o processo no e-Docs pois ainda não foi enviado nenhum documento.',
				)
				return
			}

			window.open(url, '_blank')
		},
		async inicializarComponente() {
			await this.carregarCabecalho()

			this.route = {
				name: this.$route.query.origin || routesNames.ATA.ATA_ACESSAR_GESTAO_PEDIDO_VIEW,
			}

			if (this.route.name === routesNames.ATA.ATA_ACESSAR_GESTAO_PEDIDO_VIEW) {
				this.route.params = {
					id: this.informacoesPedido.ataRegistroPreco?.id,
				}
			}

			await this.carregarInformacoesOcorrencia()
		},

		async carregarInformacoesOcorrencia() {
			this.$store.commit(mutationTypes.OCORRENCIA.SET_INFORMACOES_OCORRENCIA, {
				idEntidade: this.informacoesPedido.id,
				tipoEntidade: TipoOcorrencia.PEDIDO_UTILIZACAO.value,
			})
		},
		async autorizarPedido() {
			await this.$store.dispatch(actionTypes.PEDIDO.AUTORIZAR_PEDIDO, this.idPedido)
			this.mostrarNotificacaoSucessoDefault()
			await this.buscarInformacoesDoPedido()
			this.fecharModal()
		},
		async enviarPedidoIntegracao() {
			await this.$store.dispatch(actionTypes.PEDIDO.INTEGRACAO.ENVIAR, this.idPedido)
			this.mostrarNotificacaoSucessoDefault()
		},
		async naoAutorizarPedido() {
			await this.$store.dispatch(actionTypes.PEDIDO.NAO_AUTORIZAR_PEDIDO, this.idPedido)
			this.mostrarNotificacaoSucessoDefault()
			await this.buscarInformacoesDoPedido()
			this.fecharModal()
		},
		async concluirPedido() {
			await this.$store.dispatch(actionTypes.PEDIDO.CONCLUIR_PEDIDO, this.idPedido)
			this.mostrarNotificacaoSucessoDefault()
			await this.buscarInformacoesDoPedido()
			this.abrirModalConfirmacaoConcluirPedido()
		},
		async efetivarPedido() {
			await this.$store.dispatch(actionTypes.PEDIDO.EFETIVAR_PEDIDO, this.idPedido)
			await this.encaminharFluxoAtividadeRecebimentoEntrega()
			await this.buscarInformacoesDoPedido()
			this.mostrarNotificacaoSucesso('Pedido EFETIVADO com sucesso!')
			this.fecharModal()
			this.atualizarListagem++
			this.mostrarNotificacaoSucesso('Os documentos do pedido estão sendo gerados.')
		},
		async encaminharFluxoAtividadeRecebimentoEntrega() {
			if (!this.isIntegracaoRecebimentoEntregaAtivo || !this.keyAtividadeRecebimentoEntrega) return

			const body = {
				idEntidade: this.idPedido,
				keyProximaAtividade: this.keyAtividadeRecebimentoEntrega,
				processKey: this.process_key,
			}

			try {
				await this.$store.dispatch(actionTypes.BPM.ENCAMINHAR_ATIVIDADE, body)
			} catch (e) {
				// eslint-disable-next-line no-console
				console.error(e)
			}
		},
		abrirModalConfirmacaoConcluirPedido() {
			this.exibirModalConcluirPedido = !this.exibirModalConcluirPedido
		},
		abrirModalAutorizarPedido() {
			this.exibirModalAutorizarPedido = true
		},
		abrirModalNaoAutorizarPedido() {
			this.exibirModalNaoAutorizarPedido = true
		},
		podeExibirConcluirPedido() {
			return (
				!this.estaConcluido(this.informacoesPedido.situacao) &&
				this.isPermissaoAutorizada(this.permissoes.pedidoUtilizacaoPedidoUtilizacaoConcluir) &&
				this.hasAuthority &&
				!this.isAtaCancelada
			)
		},
		podeExibirEfetivarPedido() {
			return (
				!this.itemEstaEfetivado(this.informacoesPedido) &&
				this.isPermissaoAutorizada(this.permissoes.pedidoUtilizacaoEfetivar) &&
				this.informacoesPedido.podeEfetivarPedido &&
				this.hasAuthority &&
				!this.isAtaCancelada
			)
		},
		podeExibirAutorizarPedido() {
			return (
				this.naoTemAutorizacaoRealizada(this.informacoesPedido) &&
				this.hasAuthority &&
				this.isPermissaoAutorizada(this.permissoes.pedidoUtilizacaoedidoUtilizacaoAutorizar) &&
				!this.isAtaCancelada
			)
		},
		podeExibirBotaoProcessoDigitalNoMenuAcoes() {
			return this.podeExibirBotaoProcessoDigital && this.existeRevisaoParaPedido
		},
		podeExibirBotaoEnviarEdocs() {
			return this.podeExibirBotaoProcessoDigitalNoMenuAcoes && this.isIntegracaoEdocsAtivo && !this.isAtaCancelada
		},
		podeExibirEnviarPedidoIntegracao() {
			return this.estaConcluido(this.informacoesPedido.situacao) && !this.isAtaCancelada
		},
		getTodasPermissoesBotaoMenuCabecalho() {
			return {
				deveAutorizarPedido: () => this.podeExibirAutorizarPedido(),
				deveConcluirPedido: () => this.podeExibirConcluirPedido(),
				deveEfetivarPedido: () => this.podeExibirEfetivarPedido(),
				deveEnviarParaIntegracao: () => this.podeExibirEnviarPedidoIntegracao(),
			}
		},
		enviarEdocs() {
			this.exibirModalEdocs = true
		},
		fecharModalEdocs() {
			const painelTabsRef = this.$refs.painelTabsRef
			if (this.$route.name === routesNames.PEDIDO.ACESSAR_DOCUMENTOS_VIEW) {
				painelTabsRef.$refs.childRef.buscarDocumentos()
			}

			this.exibirModalEdocs = false
		},
		async acoesAposRevisao() {
			if (this.revisao.encaminhamentoAutomatico === 'SIM') {
				await Promise.all([
					this.setBpmProcess(),
					this.carregarCabecalho(),
					this.carregarInstancia(this.$route.params.id.toString()),
				])
			} else {
				this.mostrarNotificacaoSucesso('Documento gerado com sucesso')
			}

			await this.$router.push({
				name: routesNames.PEDIDO.ACESSAR_ITENS_VIEW,
				params: {
					id: this.idPedido,
					tipoAcesso: 'editar',
				},
			})
		},
		async criarRevisaoPedidoUtilizacao() {
			await this.$store.dispatch(actionTypes.PEDIDO.REVISOES.CRIAR, {
				idPedido: this.idPedido,
				body: {
					idRevisao: this.revisao?.id,
				},
			})
			await this.acoesAposRevisao()
		},
		async acaoAposFluxo() {
			await this.carregarCabecalho()
		},
	},
}
</script>
<style lang="stylus">
.acessar-pedido-view
	&__btn-bpm
		padding 0 12px !important
		min-width auto !important
		font-size (13 / 16) rem !important

	.label
		font-weight bold !important
		font-size 0.75em !important

	.subtitulo
		font-size 0.8em !important

	.acessar-pedido-menu-acoes-cabecalho
		margin-right 8px

		button
			border none
			color white !important

.pedido-view-modal-confirmacao
	&__texto-titulo
		color #404040
		width 98%
		text-align center
		margin-left 18px
		margin-right 17px
		font-weight 700
		font-size 22px
		line-height 26px

	&__close-modal-mobile
		position absolute !important
		right 20px !important
</style>
